import { TooltipProvider } from '@radix-ui/react-tooltip'
import { Buffer } from 'buffer'
import { SnackbarProvider } from 'notistack'
import { CookiesProvider } from 'react-cookie'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { WagmiConfig } from 'wagmi'
import { ReactQueryClientProvider } from '../../features/react-query-provider/ReactQueryClientProvider'
import { CreateRedirect, Redirects } from '../../features/redirects'
import { withLDConfig } from '../../features/with-ld'
import Web3Client from '../lib/wagmi/connectors'
import Arp from './internal/arp'
import { ArpDetails } from './internal/arp/ArpDetails'
import ArpMediaVisualizerPage from './internal/ArpMediaVisualizerPage'
import InternalRoute from './internal/components/InternalRoute'
import DraftsGodlist from './internal/DraftsGodlist'
import InternalDashboard from './internal/InternalDashboard'
import { News } from './internal/news'
import { Create as CreateNews } from './internal/news/Create'
import { NewsDetails } from './internal/news/NewsDetails'
import { SamplePacks } from './internal/sample-packs'
import { CreateSamplePack } from './internal/sample-packs/CreateSamplePack'
import { EditSamplePack } from './internal/sample-packs/EditSamplePack'
import { SamplePackDetails } from './internal/sample-packs/SamplePackDetails'
import UsersDashboard from './internal/UsersDashboard'

window.Buffer = window.Buffer || Buffer
export const InternalEndpoint = 'vPsCKXcUxA'

export const App = withLDConfig()(() => {
  return (
    <ReactQueryClientProvider>
      <CookiesProvider>
        <TooltipProvider>
          <Routes>
            <Route path={`/${InternalEndpoint}`}>
              <Route
                index
                element={
                  <InternalRoute>
                    <InternalDashboard />
                  </InternalRoute>
                }
              />
              <Route
                path={`/${InternalEndpoint}/users`}
                element={
                  <InternalRoute>
                    <UsersDashboard />
                  </InternalRoute>
                }
              />
              <Route
                path={`/${InternalEndpoint}/drafts-godlist`}
                element={
                  <InternalRoute>
                    <DraftsGodlist />
                  </InternalRoute>
                }
              />
              <Route
                path={`/${InternalEndpoint}/arp`}
                element={
                  <InternalRoute>
                    <Arp />
                  </InternalRoute>
                }
              />
              <Route
                path={`/${InternalEndpoint}/arp/:id`}
                element={
                  <InternalRoute>
                    <ArpDetails />
                  </InternalRoute>
                }
              />
              <Route
                path={`/${InternalEndpoint}/news`}
                element={
                  <InternalRoute>
                    <News />
                  </InternalRoute>
                }
              />
              <Route
                path={`/${InternalEndpoint}/news/:id`}
                element={
                  <InternalRoute>
                    <NewsDetails />
                  </InternalRoute>
                }
              />
              <Route
                path={`/${InternalEndpoint}/news/create`}
                element={
                  <InternalRoute>
                    <CreateNews />
                  </InternalRoute>
                }
              />
              <Route
                path={`/${InternalEndpoint}/sample-packs`}
                element={
                  <InternalRoute>
                    <SamplePacks />
                  </InternalRoute>
                }
              />
              <Route
                path={`/${InternalEndpoint}/sample-packs/:id`}
                element={
                  <InternalRoute>
                    <SamplePackDetails />
                  </InternalRoute>
                }
              />
              <Route
                path={`/${InternalEndpoint}/sample-packs/:id/edit`}
                element={
                  <InternalRoute>
                    <EditSamplePack />
                  </InternalRoute>
                }
              />
              <Route
                path={`/${InternalEndpoint}/sample-packs/create`}
                element={
                  <InternalRoute>
                    <CreateSamplePack />
                  </InternalRoute>
                }
              />
              <Route
                path={`/${InternalEndpoint}/arp-visualizer`}
                element={
                  <InternalRoute>
                    <ArpMediaVisualizerPage />
                  </InternalRoute>
                }
              />
            </Route>
            <Route
              path={`/${InternalEndpoint}/redirects`}
              element={
                <InternalRoute>
                  <Redirects />
                </InternalRoute>
              }
            />
            <Route
              path={`/${InternalEndpoint}/redirects/create`}
              element={
                <InternalRoute>
                  <CreateRedirect />
                </InternalRoute>
              }
            />
          </Routes>
        </TooltipProvider>
      </CookiesProvider>
    </ReactQueryClientProvider>
  )
})

const appDiv = document.getElementById('app')
const root = createRoot(appDiv)

root.render(
  <SnackbarProvider>
    <WagmiConfig client={Web3Client}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </WagmiConfig>
  </SnackbarProvider>
)
